import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

export interface EmptyPanelProps {
  align?: 'center' | 'left'
  children: ReactNode
  className?: string
  variant?: 'dashed' | 'plain'
}

export function EmptyPanel({
  align = 'left',
  children,
  className,
  variant = 'dashed',
}: EmptyPanelProps) {
  return (
    <div
      className={cn(
        'rounded-lg px-4 py-8 text-sm text-[var(--color-text-muted)]',
        variant === 'dashed'
          ? 'border border-dashed border-[var(--color-border)] bg-[#fbfbfb]'
          : 'bg-[var(--color-surface-muted)]',
        align === 'center' ? 'text-center' : null,
        className,
      )}
    >
      {children}
    </div>
  )
}
